module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-stone-path-background.f46a8b01.png";